<template>
  <v-container fluid class="ma-0 pa-0" style="max-height: calc(100vh - 108px)">
    <!-- <HomeBar /> -->

    <div class="menuleft">
      <v-navigation-drawer permanent width="100%">
        <v-row class="mt-1">
          <v-col cols="12" style="background: #fafafa">
            <v-text-field
              v-model="input"
              rounded
              solo
              flat
              dense
              id="search"
              :label="t('pesquisarContatos')"
              hide-details
            >
              <template v-slot:append>
                <v-icon>mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-list two-line subheader>
          <v-virtual-scroll
            :items="filtroClientes"
            :item-height="80"
            :height="800"
          >
            <template v-slot="{ item }">
              <v-list-item :key="item.id" @click="select(item)">
                <v-list-item-avatar>
                  <v-avatar color="deep-orange ">
                    <v-icon dark>mdi-account</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.nome"></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.numero ? item.numero : item.email"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="item.id" inset></v-divider>
            </template>
          </v-virtual-scroll>
        </v-list>
      </v-navigation-drawer>
    </div>
  </v-container>
</template>
   
<script>
import HomeBar from "../bars/Home";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import moment from "moment";
import filter from "../../plugins/Filter";
import { debounce } from "../../plugins/Debounce";

export default {
  name: "Left-Menu",
  components: {
    HomeBar,
  },
  props: {
    title: { type: String, default: "Title" },
  },
  data() {
    return {
      search: null,
      input: "",
      menu: false,
    };
  },
  created() {
    if (!this.clientes || this.clientes.length == 0) this.getClientes();
  },
  watch: {
    input: debounce(function (newVal) {
      this.search = newVal;
    }, 500),
  },
  methods: {
    ...mapActions("xc", ["selectCliente", "getDefault", "getClientes"]),
    select(item) {
      this.selectCliente(item);
    },
    filterByQueue() {
      let filas = this.user.filas.map((f) => f.fila);
      let atendimentos = this.atendimentosSearch.filter((a) => {
        if (filas.indexOf(a.queue) !== -1) {
          return true;
        }
      });
      return atendimentos;
    },
    // getAtendimentos() {
    //   if (!this.dataIni) {
    //     this.dataIni = new Date();
    //     this.dataIni = moment(this.dataIni).subtract(1, "months");
    //     this.dataIni = moment(this.dataIni).format();
    //   }
    //   if (!this.dataFim) {
    //     this.dataFim = new Date();
    //     this.dataFim = moment(this.dataFim).format();
    //   }
    //   this.getAllAtendimentos({
    //     dataIni: this.dataIni,
    //     dataFim: this.dataFim,
    //   });
    // },
    formataHora(dataHora) {
      return moment(dataHora).format("HH:mm");
    },
  },
  computed: {
    ...mapState("xc", {
      clientes: (state) => state.clientes,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
      nome: (state) => state.user.fullname,
      filas: (state) => state.user.filas,
    }),
    filtroByGrupo: function () {
      if (!this.clientes) return;
      return this.clientes.filter((c) => {
        let retorna = false;
        if (c.clienteGrupo.length > 0) {
          for (let grupo of c.clienteGrupo) {
            let fila = this.filas.find((f) => grupo.rota === f.fila);
            if (fila) retorna = true;
            if (this.user.visualiza_todos_clientes) retorna = true;
            //if (grupo.rota === this.user.fullname) retorna = true;
          }
        } else {
          retorna = true;
          // if (this.user.visualiza_todos_clientes) {
          //   retorna = true;
          // } else {
          //   retorna = false;
          // }
        }

        if (retorna) return c;
      });
    },
    filtroClientes: function () {
      if (this.search && this.search.length > 0) {
        return filter.transform(this.filtroByGrupo, this.search, [
          `id`,
          `numero`,
          `nome`,
          `email`,
          `documento`,
        ]);
      } else {
        return this.filtroByGrupo;
      }
    },
  },
};
</script>

<style scoped>
.menuleft {
  margin-top: 2px;
  height: calc(100vh - 110px);
  overflow-y: auto;
}
</style>